import MojitoCore from 'mojito/core';
import PrebuiltBetBuilderCouponSkeletonImpl from './pre-built-bet-builder-coupon-skeleton';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays skeleton for pre built bet builder coupon.
 *
 * @class PrebuiltBetBuilderCouponSkeleton
 * @memberof Mojito.Modules.PrebuiltBetBuilderCoupon
 */

export default UIView('PrebuiltBetBuilderCouponSkeleton', PrebuiltBetBuilderCouponSkeletonImpl);
